import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Modal, Input, DatePicker, Space, ConfigProvider } from "antd";
import { Image } from "@chakra-ui/image";
import { exportCipRollout, formCIP } from "../../utils/api/formsApi.js";
import dayjs from 'dayjs';
import 'antd/dist/reset.css';

const baseUrl = process.env.REACT_APP_LINK

function CipRollout() {
  const [details, setMessage] = useState({ message: "", type: "" });
  const [showToast, setShowToast] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState({
    agent: "",
    dateTo: new Date(),
    dateFrom: new Date(),
  });
  const [show, setShow] = useState(false);
  const [image, setImage] = useState("");
  const imageRef = useRef()
  const [fileName, setFileName] = useState("");
  const [exportable, setExportable] = useState({ items: [], headers: [] });
  const [width, setWidth] = useState(window.innerWidth);
  const [page, setPage] = useState("1");
  const [size, setSize] = useState("");

  const columns = [
    {
      title: <span className="text-white px-2 py-1 block">ID</span>,
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 80,
    },
    {
      title: <span className="text-white px-2 py-1 block">MERCHANT NAME</span>,
      dataIndex: 'merchant',
      key: 'merchant',
      align: "center",
      width: 200,
    },
    {
      title: <span className="text-white px-2 py-1 block">ACKNOWLEDGEMENT</span>,
      dataIndex: 'acknowledgement_receipt',
      key: 'acknowledgement',
      align: "center",
      width: 150,
      render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Acknowledgement Receipt')}>View Photo</a> : '',
    },
    {
      title: <span className="text-white px-2 py-1 block">PROGRAM</span>,
      dataIndex: 'program_participation',
      key: 'program',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white px-2 py-1 block">PREFERRED</span>,
      dataIndex: 'preferred_incentive',
      key: 'preferred',
      align: "center",
      width: 120,
    },
    {
      title: <span className="text-white py-1 block">MOBILE NUMBER</span>,
      dataIndex: 'mobile_number',
      key: 'mobile',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white py-1 block">TOTAL TERMINAL</span>,
      dataIndex: 'total_terminals_joined',
      key: 'total_terminal',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white py-1 block">MID TERMINAL</span>,
      dataIndex: 'mid_terminals_joined',
      key: 'mid_terminal',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white py-1 block">SQR TERMINAL</span>,
      dataIndex: 'total_sqr_joined',
      key: 'sqr_terminal',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white py-1 block">STORE CODE</span>,
      dataIndex: 'store_code_sqr',
      key: 'store_code',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white py-1 block">POC NAME</span>,
      dataIndex: 'poc_name',
      key: 'poc_name',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white py-1 block">POC POSITION</span>,
      dataIndex: 'poc_position',
      key: 'poc_position',
      align: "center",
      width: 150,
    },
    {
      title: <span className="text-white py-1 block">DATE SIGNED</span>,
      dataIndex: 'date_signed',
      key: 'date_signed',
      align: "center",
      width: 150,
      render: (date) => date ? dayjs(date).format('YYYY-MM-DD') : '',
    },
     {
      title: <span className="text-white py-1 block">REASON NOT JOINED MALL CHAMPION</span>,
      dataIndex: 'reason_not_joined_mall_champion',
      key: 'reason_not_joined_mall_champion',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">JOINED MAYA KITA CLUB</span>,
      dataIndex: 'joined_maya_kita_club',
      key: 'joined_maya_kita_club',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">WHICH ACQUIRER</span>,
      dataIndex: 'which_acquirer',
      key: 'which_acquirer',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">ON GOING PROMO</span>,
      dataIndex: 'on_going_promo',
      key: 'on_going_promo',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">PROMO TITLE</span>,
      dataIndex: 'promo_title',
      key: 'promo_title',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">PROMO MECHANICS</span>,
      dataIndex: 'promo_mechanics',
      key: 'promo_mechanics',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">DURATION</span>,
      dataIndex: 'duration',
      key: 'duration',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">PROMO MERCH MATS</span>,
      dataIndex: 'promo_merch_mats',
      key: 'promo_merch_mats',
      align: "center",
      width: 150,
    },
     {
      title: <span className="text-white py-1 block">STORE FRONT PHOTO</span>,
      dataIndex: 'store_front_photo',
      key: 'store_front_photo',
      align: "center",
      width: 150,
      render: (url) => url ? <a href="#" onClick={() => handleShow(url, 'Store Front Photo')}>View Photo</a> : '',
    },
    {
      title: <span className="text-white py-1 block">ADDED BY</span>,
      dataIndex: 'added_by',
      key: 'added_by',
      width: 200,
      align: "center",
    },
    {
      title: <span className="text-white py-1 block">ADDED ON</span>,
      dataIndex: 'added_on',
      key: 'added_on',
      width: 200,
      align: "center",
      render: (value) => value ? dayjs(value).format('MMM DD, YYYY hh:mm A') : '-',
    },
  ];

  window.addEventListener("resize", () => {
    setWidth(window.innerWidth);
  });

  const handleClose = () => setShow(false);
  const handleShow = (image, file) => {
    setFileName(file);
    setImage(image);
    setShow(true);
    imageRef.current = `${baseUrl}${image}`;
  };

  const handleSearch = async (page = 1, pageSize = 10) => {
    setLoading(true);
    setPage(page); 
    try {
      const response = await formCIP(searchData, page)

      if (response?.data?.data) {
        const data = response.data.data;
        setSize(response.data.total_cip);
        setData(data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      // You might want to show an error message to the user here
    } finally {
      setLoading(false);
    }
  };

  async function handleExport() {
    await exportCipRollout(searchData);
  }

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#FB9C0C',
          borderRadius: 6,
        },
      }}
    >
    <div className="p-2">
      {showToast && (
        <div className={`alert alert-${details.type}`}>
          {details.message}
          <button type="button" className="btn-close" onClick={() => setShowToast(false)}></button>
        </div>
      )}
      <div className="text-center">
        <div className="col-12">
          <h1 className="title">CIP ROLLOUT</h1>
        </div>
      </div>
      <div className="d-flex flex-wrap gap-3 mb-4 align-items-end">
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Date From</label>
          <DatePicker
            style={{ width: '100%' }}
            value={searchData.dateFrom ? dayjs(searchData.dateFrom) : null}
            onChange={(date) => setSearchData({ ...searchData, dateFrom: date })}
            format="YYYY-MM-DD"
            allowClear={false}
          />
        </div>
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Date To</label>
          <DatePicker
            style={{ width: '100%' }}
            value={searchData.dateTo ? dayjs(searchData.dateTo) : null}
            onChange={(date) => setSearchData({ ...searchData, dateTo: date })}
            format="YYYY-MM-DD"
            allowClear={false}
          />
        </div>
        <div style={{ width: "250px" }}>
          <label style={{ fontWeight: 500, marginBottom: 4, display: 'block' }}>Agent</label>
          <Input
            placeholder="Search Agent"
            value={searchData.agent}
            onChange={(e) => setSearchData({ ...searchData, agent: e.target.value })}
          />
        </div>
        <div className="d-flex align-items-end">
          <Space>
            <Button type="primary" onClick={() => handleSearch()}>
              Search
            </Button>
            <Button type="primary" onClick={handleExport} disabled={!data || data.length === 0}>
              Export
            </Button>
          </Space>
        </div>
      </div>
      <div className="row">
              <div className="col-12">
                <div style={{ overflowX: 'auto', maxHeight: '70vh', overflowY: 'auto' }}>
                  <Table
                    // className="no-hover"
                    columns={columns}
                    dataSource={data}
                    rowKey="id"
                    pagination={{
                      current: parseInt(page),
                      pageSize: 10,
                      total: size,
                      showSizeChanger: true,
                      pageSizeOptions: ['10', '20', '50', '100'],
                      showTotal: (total) => `Total ${total} items`,
                      onChange: (page, pageSize) => handleSearch(page, pageSize),
                    }}
                    scroll={{ x: 'max-content' }}
                bordered
                size="small"
                loading={loading}
              />
                </div>
              </div>
            </div>
      <Modal 
        title={fileName} 
        open={show} 
        onCancel={handleClose}
        footer={null}
        centered
      >
        <div className="text-center">
          <Image
            src={imageRef.current}
            // fallbackSrc="../../logo.png"
            alt="CIP Image"
            style={{ 
              maxWidth: "100%", 
              maxHeight: width > 768 ? "70vh" : "50vh",
              objectFit: 'contain'
            }}
            className="img-fluid mx-auto"
          />
        </div>
      </Modal>
    </div>
    </ConfigProvider>
  );
}

export default CipRollout;
